module.exports = __webpack_public_path__ + "static/media/008.53b0b636.jpg";